import featureFlag from '@/config/featureFlag'

interface BasePassengerInfo {
  defaultAdultsCount?: number
  defaultChildrenCount?: number
}

export function useBasePassengerInfo({
  defaultAdultsCount = featureFlag.passengersDefaultCount.adults,
  defaultChildrenCount = featureFlag.passengersDefaultCount.children,
}: BasePassengerInfo = {}) {
  return {
    adults: defaultAdultsCount,
    children: defaultChildrenCount,
    childrenAges: [],
  }
}
